import React from 'react';
import { toast, ToastType } from 'react-toastify';
import { MdError } from 'react-icons/md';
import { TiWarning } from 'react-icons/ti';
import { IoMdCheckmarkCircle } from 'react-icons/io';
import { FaInfoCircle } from 'react-icons/fa';
import AssignmentIndOutlinedIcon from '@material-ui/icons/AssignmentIndOutlined';
import { Person } from '@material-ui/icons';
import { grey } from '@material-ui/core/colors';
import Transition from '@material-ui/icons/TransferWithinAStationOutlined';
import BusinessOutlinedIcon from '@material-ui/icons/BusinessOutlined';
import LocationCityIcon from '@material-ui/icons/LocationCity';
import AssignmentOutlinedIcon from '@material-ui/icons/AssignmentOutlined';
import { NavLink } from 'react-router-dom';
import { convertToLocalDate } from '../utils/date';

const iconSize = '1.5em';

function GetTostMsgComponent(message, title, toastType) {
  return (
    <div className="row">
      {toastType && (
        <>
          <div className='notification-header'>
            {title && <div className="col-xs-11 col-lg-12 no-padding" style={{ fontWeight: '400' }}><span style={{ fontSize: '0.9rem !important', paddingLeft: '44px' }}>{title}</span></div>}
          </div>
          <div className="notification-sub-message">
            <div className="notification-sub-icon">
              {toastType === ToastType.ERROR && <MdError size={iconSize} />}
              {toastType === ToastType.SUCCESS && (
                <IoMdCheckmarkCircle size={iconSize} />
              )}
              {toastType === ToastType.INFO && <FaInfoCircle size={iconSize} />}
              {toastType === ToastType.WARNING && <TiWarning size={iconSize} />}
              {toastType === ToastType.DEFAULT && <FaInfoCircle size={iconSize} />}
            </div>
            <div className="col-xs-11 toast-sub-message">{message}</div>
          </div>
        </>
      )}
      {toastType && title ? <div className="col-xs-2">&nbsp;</div> : ''}
    </div>
  );
}

function GetNotificationMsgComponent(message, title, category, isClickable = false, user, createdDateTime, isApprovedNotification) {
  return (
    <div className="row">
      <div className='notification-header'>
        {category === 'PTF' && <Transition style={{ color: grey[50] }} />}
        {category === 'Allocations' && <AssignmentIndOutlinedIcon style={{ color: grey[50] }} size={iconSize} />}
        {/* <FaInfoCircle size={iconSize} /> */}
        {category === 'Transitions' && <Transition style={{ color: grey[50] }} />}
        {category === 'Employees' && <Person style={{ color: grey[50] }} size={iconSize} />}
        {category === 'Properties' && <BusinessOutlinedIcon style={{ color: grey[50] }} />}
        {category === 'Markets' && <LocationCityIcon style={{ color: grey[50] }} />}
        {category === 'Assignments' && <AssignmentOutlinedIcon style={{ color: grey[50] }} />}
        {/* <div className="col-xs-1 no-padding" style={{ marginRight: '10px' }}> */}
        {title && <div className="col-xs-11 toast-title no-padding">{title}</div>}
        {/* </div> */}
      </div>
      {toastType && title ? <div className="col-xs-0">&nbsp;</div> : ''}
      <div className="col-xs-12">
        <hr />
      </div>
      <div className='notification-sub-message'>
        <div className='notification-sub-icon'>
          {!isClickable && <FaInfoCircle size={iconSize} />}
          {isClickable && <TiWarning size={iconSize} />}
        </div>
        {message.indexOf('(Review') === -1 &&
          <div className="col-xs-11 toast-sub-message">{message}</div>
        }
        {message.indexOf('(Review') !== -1 &&
          <>
            <div className="col-xs-11 toast-sub-message">{message.split('(Review')[0]}
              <br />
              {message.slice(message.indexOf('(Review'))}
            </div>
          </>
        }
      </div>
      <div className='notification-request'>
        {isApprovedNotification && <h2>Approved By: <span>{user}</span> </h2>}
        {!isApprovedNotification && <h2>Requested By: <span>{user}</span> </h2>}
        {/* <p>On: <span>{moment(createdDateTime).format('YYYY/MM/DD HH:mm:ss')}</span></p> */}
        <p>On: <span>{createdDateTime ? convertToLocalDate(createdDateTime, 'MM-DD-YYYY hh:mm A') : '-'}</span></p>
        {isClickable && <NavLink to={'/pendingRequests'}
          style={{ cursor: 'pointer', color: 'white' }}><span>{'View Details'}</span></NavLink>}
      </div>
    </div>
  );
}

export function ShowToast(
  message,
  toastType,
  autoclose,
  messageId = 0,
  title = ''
) {
  if (message) {
    if (toastType === toastType.SUCCESS) {
      autoclose = autoclose === false ? 5000 : autoclose;
    }
    if (!toast.isActive(messageId)) {
      const options = {
        pauseOnFocusLoss: true,
        pauseOnHover: true,
        autoClose: autoclose,
        toastId: messageId
      };
      switch (toastType) {
        case ToastType.ERROR:
          toast.error(() => GetTostMsgComponent(message, title, toastType), { ...options });
          break;
        case ToastType.SUCCESS:
          toast.success(() => GetTostMsgComponent(message, title, toastType), { ...options });
          break;
        case ToastType.WARNING:
          toast.warn(() => GetTostMsgComponent(message, title, toastType), { ...options });
          break;
        case ToastType.INFO:
          toast.info(() => GetTostMsgComponent(message, title, toastType), { ...options });
          break;
        case ToastType.DEFAULT:
        default:
          toast(() => GetTostMsgComponent(message, title, toastType), { ...options });
          break;
      }
    }
  }
}

export function ShowNotification(
  message,
  autoclose = 8000,
  messageId = 0,
  title = '',
  category = '',
  isClickable = false,
  user,
  createdDateTime,
  isApprovedNotification
) {
  const options = {
    autoClose: autoclose,
    toastId: messageId,
    position: toast.POSITION.BOTTOM_RIGHT,
    pauseOnFocusLoss: false,
    pauseOnHover: true,
    hideProgressBar: false
  };
  if (message) {
    if (!toast.isActive(messageId)) {
      if (isApprovedNotification) {
        toast.info(() => GetNotificationMsgComponent(message, title, category, isClickable, user, createdDateTime, isApprovedNotification), {
          ...options,
          className: 'notify-info'
        });
      } else {
        if (isClickable) {
          toast.warn(() => GetNotificationMsgComponent(message, title, category, isClickable, user, createdDateTime, isApprovedNotification), {
            ...options,
            className: 'notify-warn'
          });
        } else {
          toast.info(() => GetNotificationMsgComponent(message, title, category, isClickable, user, createdDateTime, isApprovedNotification), {
            ...options,
            className: 'notify-info'
          });
        }
      }
    }
  }
}

// export function ShowPendingNotification (){
//   toast.info(() => )
// }

export const toastType = ToastType;
